module.exports = __webpack_public_path__ + "img/60f2.9a35605a.jpg";